import SectionHeading from '@/components/base/SectionHeading';
import { showToast } from '@/components/base/Toast';
import { videoList } from '@/mocks/home';

export default function VideoSection() {
  const [featured, ...rest] = videoList;

  return (
    <section id="videos" className="w-full bg-background-50">
      <div className="w-full px-4 py-16 md:px-8 md:py-20">
        <div className="mx-auto max-w-[1200px]">
          <SectionHeading
            index="02"
            eyebrow="Cos Video"
            title="cos 视频专区"
            desc="以角色扮演短片为主，包含剧情向、场景向与拍摄花絮，用动态画面补全秘书题材的视觉想象。"
            actionLabel="进入视频专区"
            onAction={() => showToast('静态展示：视频专区暂未开放')}
          />

          <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
            <button
              type="button"
              onClick={() => showToast('静态展示：视频播放暂未开放')}
              className="group relative block w-full overflow-hidden rounded-lg border border-background-300 bg-background-200 lg:col-span-8"
            >
              <div className="relative aspect-video w-full">
                <img
                  src={featured.cover}
                  alt={`${featured.title} - 善良的女秘书 cos视频封面`}
                  title={`${featured.title} - 善良的女秘书角色扮演 cos视频`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
                <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  {featured.tag}
                </span>
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-50/90 text-primary-600 transition-transform duration-300 group-hover:scale-110">
                    <i className="ri-play-fill text-3xl" />
                  </span>
                </span>
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                  <h3 className="font-heading text-lg font-bold text-background-50 md:text-xl">
                    {featured.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-4 text-xs text-background-200">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line" />
                      {featured.duration}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" />
                      {featured.views}
                    </span>
                  </div>
                </div>
              </div>
            </button>

            <div className="flex flex-col gap-5 lg:col-span-4">
              {rest.map((video) => (
                <button
                  key={video.id}
                  type="button"
                  onClick={() => showToast('静态展示：视频播放暂未开放')}
                  className="group relative block w-full overflow-hidden rounded-lg border border-background-300 bg-background-200"
                >
                  <div className="relative aspect-video w-full">
                    <img
                      src={video.cover}
                      alt={`${video.title} - 善良的女秘书 cos视频封面`}
                      title={`${video.title} - 善良的女秘书角色扮演 cos视频`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
                    <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-0.5 text-[11px] font-medium text-foreground-800">
                      {video.tag}
                    </span>
                    <span className="absolute bottom-3 right-3 rounded bg-foreground-950/75 px-2 py-0.5 text-[11px] text-background-100">
                      {video.duration}
                    </span>
                    <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-background-50/90 text-primary-600">
                        <i className="ri-play-fill text-2xl" />
                      </span>
                    </span>
                    <div className="absolute inset-x-0 bottom-0 p-4">
                      <h3 className="font-heading text-sm font-semibold text-background-50">
                        {video.title}
                      </h3>
                      <span className="mt-1 flex items-center gap-1 text-[11px] text-background-200">
                        <i className="ri-eye-line" />
                        {video.views}
                      </span>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}